import React from 'react'

import styled from '@emotion/styled'
import { useForm } from 'react-hook-form'

import { CheckIcon } from '@arcade/web/icons/react'
import { Flex, Hug, IconMat, spacing, Text } from '@cash-design-system/react'
import { PayWithCashAuthorizationBlocker } from '@cash-web/protos/squareup/franklin/blockers/pay_with_cash_authorization_blocker.pb'

import { BaseBlocker, BaseBlockerFormFields, BlockerProps, SubmitButton } from '../../BaseBlocker/BaseBlocker'

interface Props extends BlockerProps {
  blocker: PayWithCashAuthorizationBlocker
}

const buttonMaxWidth = '14rem'

const ContentCentered = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  max-width: ${buttonMaxWidth};
  margin-inline: auto;
  align-items: center;
  justify-content: center;
  padding: 1rem 0;
  text-align: center;
`

const Spacer = styled.div`
  height: ${({ theme }) => theme.spacing.m};
`

export function BlockerPayWithCashAuthorization({ blocker }: Props): React.ReactElement {
  const form = useForm<BaseBlockerFormFields>()

  const onSubmit = async () => {
    const redirectUrl = blocker.footer?.button_footer?.primary_action?.back_navigation_action?.redirect_url
    if (redirectUrl) {
      window.location.assign(redirectUrl)
    }
  }

  const { title, subtitle } = blocker

  const payingAsText = blocker.on_display_interstitial?.status_interstitial?.text

  return (
    <BaseBlocker
      actionHeader={
        (title || subtitle) && (
          <Flex fullWidth justifyContent="center">
            <Hug fullWidth maxWidth={buttonMaxWidth}>
              <Flex flexDirection="column" gap={spacing.m}>
                {title && (
                  <Text
                    typography="pageTitle"
                    as="h2"
                    color="textProminent"
                    textAlign="left"
                    textWrap="pretty"
                    overflowWrap="anywhere"
                  >
                    {title}
                  </Text>
                )}
                {subtitle && (
                  <Text typography="body" color="textSubtle" textAlign="left" textWrap="pretty" overflowWrap="anywhere">
                    {subtitle}
                  </Text>
                )}
              </Flex>
            </Hug>
          </Flex>
        )
      }
      onSubmit={onSubmit}
      form={form}
      buttons={[
        <Flex key="submit" fullWidth justifyContent="center">
          <SubmitButton />
        </Flex>,
      ]}
    >
      <ContentCentered>
        <IconMat>
          <CheckIcon size={24} data-testid="success-icon" />
        </IconMat>
        <Spacer />
        <Text typography="numeralSmall" as="h2" color="textStandard">
          {payingAsText}
        </Text>
      </ContentCentered>
    </BaseBlocker>
  )
}
